package com.fantasytenis.shared.domain.notifications.usecases

import com.fantasytenis.shared.core.utils.SharedData
import com.fantasytenis.shared.domain.notifications.NotificationsRepository

/**
 * Use case for deleting a notification.
 * Updates SharedData accordingly.
 */
class DeleteNotificationUseCase(
    private val repository: NotificationsRepository
) {
    /**
     * Delete a notification.
     *
     * @param notificationId The ID of the notification to delete
     */
    suspend operator fun invoke(notificationId: String): Result<Boolean> = runCatching {
        // Find the notification before deleting to check if it was unread
        val notification = SharedData.notifications.value.find { it.id == notificationId }
        val wasUnread = notification?.read == false

        val success = repository.deleteNotification(notificationId)

        if (success) {
            // Remove the notification from SharedData
            val current = SharedData.notifications.value
            SharedData.notifications.value = current.filter { it.id != notificationId }

            // Decrement unread count if the deleted notification was unread
            if (wasUnread) {
                val count = SharedData.unreadNotificationCount.value
                if (count > 0) {
                    SharedData.unreadNotificationCount.value = count - 1
                }
            }
        }

        success
    }
}
